// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".featured-image img[data-v-c9ebbccc]:after{position:absolute;top:0;left:0;width:100%;height:100%;display:block;content:\"\";background-color:rgba(31,31,30,.5);mix-blend-mode:multiply}", ""]);
// Exports
module.exports = exports;
